import { BrandLockup } from './BrandMark';

/**
 * Brand lockup as a home link — the official Fleetwise AI mark + wordmark.
 *
 * See BrandMark.tsx for why the mark is theme-swapped and the wordmark is real
 * text rather than the lockup SVG's baked-in text.
 */
export function Wordmark({ textClassName }: { textClassName?: string }) {
  return (
    <a
      href="/"
      className="group inline-flex min-h-11 items-center"
      aria-label="Fleetwise AI home"
      title="Fleetwise AI"
    >
      <BrandLockup
        className="transition-transform duration-200 group-hover:scale-[1.03]"
        textClassName={textClassName}
      />
    </a>
  );
}
